import React, { useState, useEffect, Fragment } from "react";
import "./Sidebar.css";
import MissionModelingService from "../MissionModelingService";
import SpaceObjectContainer from "./SpaceObject/SpaceObjectContainer";
import GsSpaceObjectContainer from "./GsSpaceObjectContainer";
import AoiSpaceObjectContainer from "./AoiSpaceObjectContainer";
import { components } from "react-select";
import { useParams } from "react-router-dom";
interface Plane {
  planeId: number;
  name: string;
}


const Sidebar = ({  props }) => {
  const params = useParams()
  const {
    mission_name,
    mission_id
  } = params;
  const [component, setShowComponent] = useState("Satellite");
  const [planes, setPlanes] = useState<Plane[]>([]);
  const [aois, setAois] = useState<Plane[]>([]);
  const [Gs, setGs] = useState<Plane[]>([]);

  const [SidebarData, setSidebarData] = useState({});

  const showSidebar = () => {
    props.setSidebarProps({
      isSidebarVisible: !props.isSidebarVisible,
      sidebarComponent: props.sidebarComponent,
      isComponentUpdated: props.isComponentUpdated,
    });
  };

  useEffect(()=>{
    switch(props.bottombarComponent){
      case "Area of Interest" :
        showComponent("Area of Interest");
        break;
      case "Satellite" :
        showComponent("Satellite");
        break;
      case "Ground Station" :
        showComponent("Ground Station");
        break;
    }
  },[props.bottombarComponent])

  const showComponent = (component) => {
    setShowComponent(component);
    props.setSidebarProps({
      sidebarComponent: component,
      isSidebarVisible: props.isSidebarVisible,
      isComponentUpdated: props.isComponentUpdated,
    });
  };

  const find_componentType = (selectedSpaceObjectName) => {
    if (selectedSpaceObjectName?.includes("SpaceCraft") || selectedSpaceObjectName?.includes("SpaceObject")|| selectedSpaceObjectName?.includes("Constellation") ){
      return "Spaceobject";
    } else if (selectedSpaceObjectName?.includes("Satellite")) {
      return "Satellite";
    } else if (selectedSpaceObjectName?.includes("Plane")) {
      return "Plane";
    }
     else if (selectedSpaceObjectName?.includes("Area of Interest")) {
     return "Aoi";
  }
  }

  const setVisualisationProperties = (selectedSpaceObjectName,selectedSpaceObjectId) => {
    let componentType = component === 'Ground Station' ? component : find_componentType(selectedSpaceObjectName);
    props.setVisualisationProps({
      selectedComponent: componentType===undefined? component : componentType,
      selectedComponentId: selectedSpaceObjectId,
      selectedComponentName: selectedSpaceObjectName,
    });
  };
  const getAllAreaOfInterest = () => {
    MissionModelingService.getAllAreaOfInterest(mission_id)
      .then((res) => {
        // props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
        if(res?.data){
          setAois(res?.["data"]);
          props.setNames({
            ...props.names,
            areaOfInterestLatestName: res?.data[res?.data?.length-1]?.name,
          });
       
         props.setOrbitDataList((previousState) => ({
              ...previousState,
              aoiList : res?.data
          }))
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllPlanes = () => {
    MissionModelingService.getAllPlanes(mission_id)
      .then((res) => {
        if(res?.data){
          // props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
          setPlanes(res?.data);
          props.setNames({
            ...props.names,
            spaceObjectLatestName: res?.data[res?.data?.length-1]?.name,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllGroundStation = () => {
    MissionModelingService.getAllGroundStation(mission_id)
      .then((res) => {
        if(res?.data){
          // props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
          setGs(res?.data);
          props.setNames({
            ...props.names,
            groundStationLatestName: res?.data[res?.data?.length-1]?.name,
          });
         
           props.setOrbitDataList((previousState) => ({
                ...previousState,
                gsList : res?.data
            }))
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllOrbitData = () => {
    props?.setLoadingOrbitData(true)
    MissionModelingService.getAllOrbitData(mission_id).then((res) => {
      props.setOrbitDataList((previousState) => ({
        ...previousState,
        satelliteList : res?.data
    }))
    setVisualisationProperties(res?.data?.[res?.data?.length-1]?.satName, res?.data?.[res?.data?.length-1]?.satId)
    props?.setLoadingOrbitData(false)
    }).catch((err) => {
      props?.setLoadingOrbitData(false)
    })
  }

  const getCoverageAnalysisOrbit = () => {
    console.log("Inside CV Analysis")
    props?.setLoadingOrbitData(true)
    MissionModelingService.getCoverageAnalysisOrbitList(mission_id).then((res) => {
      props?.setLoadingOrbitData(false)           
      props.setOrbitDataList((previousState) => ({
        ...previousState,
        coverageAnalysisSatList : res?.data
      }))
      props.setIsCoverageAnalysisUpdate(!props.isCoverageAnalysisUpdate)
    }).catch((err) => {
      console.log("Erorrrrr")
      props?.setLoadingOrbitData(false)
    })
  }


  useEffect(() => {
    getAllAreaOfInterest();
    getAllPlanes();
    getAllGroundStation();
  }, [props.isComponentUpdated]);

  useEffect(()=>{
    getAllOrbitData();
  },[props.isSatelliteCreated])

  useEffect(() => {
    console.log("Hello Any Acuracy")
    getCoverageAnalysisOrbit();
  },[props?.isCAUpdate]) 
  
  useEffect(()=>{
    if(component === 'Satellite' && planes?.length >= 0){
      let data = {
        'Satellite': planes
      }
      setSidebarData(data);
    }else if(component === 'Area of Interest' && aois?.length >= 0){
      let data = {
        'Area of Interest': aois
      }
      setSidebarData(data);
    }else if(component === 'Ground Station' && Gs?.length >= 0){
      let data = {
        'Ground Station': Gs
      }
      setSidebarData(data);
    }

  },[component, planes, aois, Gs])

  const openModal = (selectedItem) => {
    {
      props.sidebarComponent === "Satellite" &&
        props.setBottombarProps({
          bottombarComponent: "Satellite",
          componentId: selectedItem?.["spaceobjectId"],
          componentData: selectedItem,
        });
    }
    {
      props.sidebarComponent === "Ground Station" &&
        props.setBottombarProps({
          bottombarComponent: "Ground Station",
          componentId: selectedItem?.["groundstationId"],
          componentData: selectedItem,
        });
    }
    {
      props.sidebarComponent === "Area of Interest" &&
        props.setBottombarProps({
          bottombarComponent: "Area of Interest",
          componentId: selectedItem?.["id"],
          componentData: selectedItem,
        });
    }
  };

  return (
        <div className={`mission__model__sidebar ${props?.isSidebarVisible ? 'active' : ''}`}>
        <div className="mission__model__sidebar__main__header">
          <button onClick={showSidebar} className='bg-transparent d-flex gap-2 align-items-center gap-3'>
            <i className='fe fe-arrow-left fs-20 '/>
            <span className='fs-18'>Mission Modeling</span>
          </button>
          <button onClick={showSidebar} className='mission__model__sidebar_close__btn'>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 7 10"
                fill="none"
              >
                <path
                  d={
                    props.isSidebarVisible
                      ? "M1.81734 5L6.34008 9.14548C6.44248 9.23935 6.5 9.36667 6.5 9.49943C6.5 9.63219 6.44248 9.75951 6.34008 9.85339C6.23769 9.94726 6.09881 10 5.95401 10C5.8092 10 5.67033 9.94726 5.56793 9.85339L0.660203 5.35396C0.609421 5.30752 0.569131 5.25235 0.541641 5.19161C0.51415 5.13087 0.5 5.06576 0.5 5C0.5 4.93424 0.51415 4.86913 0.541641 4.80839C0.569131 4.74765 0.609421 4.69248 0.660203 4.64604L5.56793 0.146613C5.67033 0.0527382 5.8092 0 5.95401 0C6.09881 0 6.23769 0.0527382 6.34008 0.146613C6.44248 0.240488 6.5 0.367809 6.5 0.500568C6.5 0.633327 6.44248 0.760649 6.34008 0.854524L1.81734 5Z"
                      : "M5.18266 5L0.659917 0.854524C0.557524 0.760649 0.5 0.633327 0.5 0.500568C0.5 0.367809 0.557524 0.240487 0.659917 0.146613C0.762311 0.0527382 0.901186 0 1.04599 0C1.1908 0 1.32967 0.0527382 1.43207 0.146613L6.3398 4.64604C6.39058 4.69248 6.43087 4.74765 6.45836 4.80839C6.48585 4.86913 6.5 4.93424 6.5 5C6.5 5.06576 6.48585 5.13087 6.45836 5.19161C6.43087 5.25235 6.39058 5.30752 6.3398 5.35396L1.43207 9.85339C1.32967 9.94726 1.1908 10 1.04599 10C0.901186 10 0.762311 9.94726 0.659917 9.85339C0.557524 9.75951 0.5 9.63219 0.5 9.49943C0.5 9.36667 0.557524 9.23935 0.659917 9.14548L5.18266 5Z"
                  }
                  fill="#CCF54E"
                />
              </svg>
          </button>
        </div>
        <div className='mission__model__sidebar__second__header'>
          <div className="mission__details__section">
            <div className="d-flex gap-3 align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.82236 3.62992C10.5404 -0.0861501 13.62 -0.15608 15.0032 0.0772158L15.007 0.0778703C15.2346 0.118834 15.4443 0.228408 15.6078 0.391887C15.7714 0.555367 15.8811 0.764955 15.9221 0.992548L15.9228 0.996424C16.1562 2.37913 16.0861 5.45726 12.3681 9.17334C11.0448 10.496 9.02208 11.5233 8.0992 11.9527C7.65846 12.1608 7.14843 12.0651 6.80652 11.7234L4.27101 9.18918C3.93878 8.85713 3.83181 8.33911 4.04207 7.89545C4.47773 6.97707 5.49838 4.95322 6.82236 3.62992ZM14.8818 0.78328C13.7281 0.589294 10.8823 0.584985 7.32881 4.13663C6.10144 5.36337 5.12531 7.28347 4.6894 8.20238C4.61449 8.36058 4.65015 8.55523 4.77745 8.68247L7.31296 11.2167C7.44614 11.3498 7.63273 11.3809 7.79389 11.3047L7.79606 11.3036C8.71185 10.8775 10.6341 9.8936 11.8617 8.66663C15.4152 5.11501 15.4108 2.27082 15.2167 1.1179C15.2014 1.03486 15.1612 0.95837 15.1014 0.898598C15.0416 0.838824 14.965 0.798605 14.8818 0.78328ZM4.76284 3.56135C4.35776 3.48202 3.9403 3.61122 3.65232 3.89905L1.26736 6.28278C1.04917 6.50085 1.12041 6.87016 1.40126 6.9912C1.40121 6.99118 1.40131 6.99122 1.40126 6.9912L2.86475 7.61901C3.1963 6.88325 4.04838 5.12114 5.21736 3.65427L4.76284 3.56135ZM3.14587 3.39234C3.60242 2.93603 4.262 2.73259 4.90244 2.85867L4.90499 2.85917L6.56066 3.19767L6.14655 3.66229C4.57358 5.42711 3.48332 7.98264 3.38078 8.22704L3.24108 8.56L1.11811 7.64928C0.369037 7.32677 0.186795 6.34988 0.760911 5.77607L3.14587 3.39234ZM10.4827 4.29692C9.80875 4.29692 9.25619 4.84946 9.25619 5.52258C9.25619 6.1957 9.80875 6.74825 10.4827 6.74825C11.1566 6.74825 11.7092 6.1957 11.7092 5.52258C11.7092 4.84946 11.1566 4.29692 10.4827 4.29692ZM8.53978 5.52258C8.53978 4.45345 9.41344 3.5805 10.4827 3.5805C11.5519 3.5805 12.4256 4.45345 12.4256 5.52258C12.4256 6.59172 11.5519 7.46466 10.4827 7.46466C9.41344 7.46466 8.53978 6.59172 8.53978 5.52258ZM12.8086 9.44267L13.1478 11.0998C13.274 11.7401 13.0703 12.3995 12.6138 12.8558L10.2288 15.2396C9.65493 15.8131 8.67784 15.6313 8.35509 14.8825L7.44375 12.7603L7.77701 12.6206C8.02155 12.5181 10.5784 11.4284 12.3442 9.8562L12.8086 9.44267ZM8.38509 13.1367L9.013 14.5989C9.13397 14.8796 9.50387 14.9512 9.72235 14.7329L12.1073 12.3491C12.3953 12.0613 12.5245 11.6442 12.4451 11.2395C12.445 11.2391 12.445 11.2387 12.4449 11.2383L12.3521 10.7851C10.8845 11.9536 9.12137 12.8053 8.38509 13.1367ZM3.74875 10.673C3.42281 10.6077 3.0858 10.6239 2.76764 10.7202C2.44947 10.8164 2.16002 10.9896 1.92497 11.2245L1.92337 11.2261C1.81323 11.3348 1.69112 11.5229 1.56584 11.7905C1.44299 12.0528 1.32771 12.3682 1.22158 12.7105C1.00946 13.3947 0.842073 14.1596 0.724201 14.7682C0.668597 15.066 0.933724 15.3315 1.23236 15.2758C1.84052 15.1581 2.60596 14.9889 3.29071 14.7758C3.63336 14.6692 3.94922 14.5537 4.21211 14.4311C4.48023 14.306 4.66908 14.1845 4.77811 14.0756C5.01307 13.8406 5.18636 13.5514 5.2826 13.2335C5.37885 12.9156 5.39507 12.5788 5.32983 12.2531L5.329 12.249C5.182 11.4676 4.53494 10.8207 3.75288 10.6738L3.74875 10.673ZM3.88729 9.97006C3.44639 9.88218 2.99059 9.90428 2.56025 10.0344C2.1296 10.1647 1.73773 10.3991 1.41938 10.7169C1.22087 10.9131 1.05602 11.1898 0.917037 11.4867C0.775444 11.789 0.649056 12.1379 0.537296 12.4984C0.313734 13.2195 0.140484 14.0143 0.0206622 14.633L0.0203285 14.6348C-0.129447 15.4293 0.571413 16.1293 1.36567 15.9797L1.36741 15.9794C1.98723 15.8595 2.78224 15.6843 3.50353 15.4599C3.86408 15.3477 4.2128 15.2213 4.51496 15.0803C4.81188 14.9418 5.08853 14.7782 5.28456 14.5823C5.60296 14.2639 5.83784 13.8719 5.96828 13.4411C6.09852 13.0109 6.12064 12.5552 6.0327 12.1145C5.83047 11.0444 4.95769 10.1721 3.88729 9.97006Z"
                  fill="#F0F0F0"
                />
              </svg>
              <span className="fs-16 opacity-75">Mission</span>
            </div>
            {/* <div className="ps-6 d-flex w-100 align-items-center justify-content-between">
              <span className="fs-14">Mission Details</span>
              <button className="bg-transparent">
                <img src={require("../ImageSvgs/Edit-Button.svg").default} />
              </button>
            </div> */}
          </div>
          <div className='second__header__icons__section'>
            <button 
              onClick={() => {
                showComponent("Satellite");
              }}
              className={`second__header__icons__section__icon ${component === "Satellite" && 'active'}`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                <path d="M12.3142 7.81075C13.3591 7.81253 14.3731 7.45692 15.1878 6.80301C15.2796 6.73009 15.3548 6.63845 15.4085 6.53419C15.4621 6.42992 15.4928 6.31544 15.4987 6.19836C15.5056 6.0743 15.4859 5.9502 15.441 5.83435C15.3961 5.71849 15.3269 5.61355 15.2382 5.52653L12.9024 3.19192C13.2301 2.8644 13.5745 2.52009 13.9022 2.18417C13.9694 2.12539 14.0283 2.0666 14.0955 1.99942C14.1703 1.91984 14.212 1.81472 14.212 1.70549C14.212 1.59627 14.1703 1.49115 14.0955 1.41157C14.0564 1.37221 14.01 1.34097 13.9588 1.31966C13.9076 1.29834 13.8527 1.28736 13.7972 1.28736C13.7417 1.28736 13.6868 1.29834 13.6356 1.31966C13.5844 1.34097 13.538 1.37221 13.4989 1.41157C13.0956 1.80627 12.7091 2.20097 12.3058 2.59567L9.96999 0.261058C9.88177 0.173947 9.77658 0.105887 9.66095 0.0611034C9.54532 0.0163198 9.42172 -0.00423213 9.29781 0.000723177C9.18087 0.00750821 9.06664 0.0386556 8.96246 0.0921659C8.85828 0.145676 8.76644 0.220367 8.69285 0.311445C7.99499 1.18272 7.63944 2.27868 7.69298 3.39347L6.47466 4.61956L4.51693 2.66285C4.44026 2.58314 4.34827 2.51973 4.24648 2.47642C4.1447 2.4331 4.03521 2.41078 3.92458 2.41078C3.81395 2.41078 3.70446 2.4331 3.60267 2.47642C3.50088 2.51973 3.40889 2.58314 3.33222 2.66285L0.744331 5.2494C0.587838 5.40674 0.5 5.61959 0.5 5.84145C0.5 6.06331 0.587838 6.27615 0.744331 6.4335L2.70625 8.39021L2.36176 8.72612C1.94616 9.14321 1.71282 9.70788 1.71282 10.2965C1.71282 10.8852 1.94616 11.4498 2.36176 11.8669L3.6305 13.135C3.83612 13.3425 4.08085 13.5072 4.35053 13.6196C4.62022 13.732 4.90952 13.7899 5.20172 13.7899C5.49391 13.7899 5.78321 13.732 6.0529 13.6196C6.32259 13.5072 6.56731 13.3425 6.77293 13.135L7.10902 12.7991L9.06675 14.7558C9.22417 14.9122 9.43713 15 9.6591 15C9.88108 15 10.094 14.9122 10.2515 14.7558L12.8393 12.1609C12.9958 12.0035 13.0837 11.7907 13.0837 11.5688C13.0837 11.3469 12.9958 11.1341 12.8393 10.9768L10.89 9.02844L12.1084 7.80235C12.1767 7.80918 12.2455 7.81198 12.3142 7.81075ZM1.33249 5.84565L3.92878 3.2507L5.8781 5.20741L3.29441 7.79396L1.33249 5.84565ZM12.247 11.573L9.6591 14.1595L7.70138 12.2028L10.2893 9.61629L12.247 11.573ZM7.85262 4.42641C8.06515 5.19616 8.47434 5.89742 9.04001 6.46133C9.60568 7.02523 10.3084 7.43239 11.0791 7.64279L6.17217 12.5472C5.91351 12.8052 5.56298 12.9501 5.19752 12.9501C4.83205 12.9501 4.48152 12.8052 4.22286 12.5472L2.94572 11.2707C2.68753 11.0122 2.54253 10.6618 2.54253 10.2965C2.54253 9.93125 2.68753 9.5809 2.94572 9.32237L7.85262 4.42641ZM9.6339 5.86244C8.97328 5.21079 8.58096 4.33537 8.5343 3.40885C8.48764 2.48234 8.79003 1.57197 9.38183 0.857307L12.0117 3.48584L14.65 6.12278L14.6668 6.14797C13.9396 6.72734 13.0243 7.01851 12.0958 6.96584C11.1673 6.91316 10.2908 6.52033 9.6339 5.86244Z" fill="#CCF54E"/>
              </svg>
            </button>
            <button 
              onClick={() => {
                showComponent("Ground Station");
              }}
              className={`second__header__icons__section__icon ${component === "Ground Station" && 'active'}`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                <path d="M11.1162 0.139716C11.6189 0.315399 12.1005 0.642994 12.4565 1.04913C13.1897 1.88414 13.1799 2.8137 12.9148 3.83524C12.9 3.89239 12.863 3.94129 12.8121 3.97118C12.7612 4.00108 12.7005 4.00952 12.6433 3.99465C12.5862 3.97978 12.5373 3.94282 12.5074 3.8919C12.4775 3.84097 12.469 3.78026 12.4839 3.72312C12.733 2.76358 12.7133 2.01642 12.1222 1.34262C11.8098 0.989202 11.4136 0.720009 10.9699 0.559804C10.5395 0.409957 10.1256 0.402723 9.80475 0.562904C9.75192 0.589216 9.6908 0.593463 9.63484 0.574713C9.57888 0.555962 9.53266 0.515749 9.50635 0.46292C9.48004 0.410091 9.47579 0.348973 9.49454 0.293012C9.51329 0.237051 9.5535 0.190831 9.60633 0.164519C10.0698 -0.0664517 10.6165 -0.0349323 11.1167 0.139716H11.1162ZM3.50499 11.9001C3.64203 11.9001 3.77346 11.8456 3.87036 11.7487C3.96727 11.6518 4.02171 11.5204 4.02171 11.3834C4.02171 11.2463 3.96727 11.1149 3.87036 11.018C3.77346 10.9211 3.64203 10.8667 3.50499 10.8667C3.36795 10.8667 3.23653 10.9211 3.13962 11.018C3.04272 11.1149 2.98828 11.2463 2.98828 11.3834C2.98828 11.5204 3.04272 11.6518 3.13962 11.7487C3.23653 11.8456 3.36795 11.9001 3.50499 11.9001Z" fill="#F0F0F0"/>
                <path d="M11.0433 2.73872C11.1423 2.98469 11.1428 3.25934 11.0447 3.50566C10.9465 3.75198 10.7573 3.95104 10.5162 4.06151L10.6304 7.80096L11.6484 8.58222C11.7514 8.66089 11.8211 8.7754 11.8436 8.90305C11.8662 9.0307 11.8399 9.16216 11.7701 9.27136C11.7002 9.38056 11.5919 9.45951 11.4666 9.49256C11.3412 9.52561 11.208 9.51034 11.0934 9.44978C10.3938 10.2057 9.52674 10.7338 8.54085 10.8707C7.90272 10.9601 7.24236 10.8816 6.57735 10.6238L6.16398 11.1797L8.60906 13.2388C8.84055 13.4336 9.01003 13.6863 9.10407 13.9669H9.14024C9.45544 13.9669 9.71017 14.1973 9.70501 14.4836C9.70501 14.7699 9.45027 15.0003 9.13456 15.0003H1.49083C1.17564 15.0003 0.920898 14.7699 0.920898 14.4836C0.920898 14.2149 1.14515 13.9953 1.43761 13.9695V11.1586C1.4375 10.8715 1.50447 10.5885 1.63318 10.332C1.76189 10.0754 1.94878 9.85255 2.17893 9.68108C2.40908 9.50961 2.67612 9.39431 2.95875 9.34437C3.24138 9.29443 3.53176 9.31124 3.80674 9.39346L4.21287 8.85815C3.76643 8.28098 3.50549 7.65783 3.42075 7.00832C3.29002 6.0059 3.58765 5.01433 4.14518 4.123C4.05008 4.03168 3.99348 3.90745 3.98698 3.77576C3.98048 3.64407 4.02457 3.51488 4.11022 3.41463C4.19587 3.31439 4.3166 3.25068 4.44769 3.23655C4.57878 3.22242 4.71031 3.25894 4.81536 3.33863L5.74286 4.05014L9.05757 3.25027C9.02633 3.00091 9.08702 2.74871 9.2283 2.54086C9.36957 2.33302 9.58175 2.18378 9.82511 2.12107C10.0685 2.05836 10.3263 2.08648 10.5505 2.20017C10.7746 2.31385 10.9501 2.50532 11.0433 2.73872ZM6.2699 4.45421L7.97609 5.76408L9.39963 3.89874C9.34433 3.8498 9.29444 3.79506 9.25082 3.73546L6.26939 4.45473L6.2699 4.45421ZM8.38584 6.07875L10.1013 7.39482L10.0021 4.15503C9.9573 4.15143 9.91276 4.14487 9.8688 4.1354L8.38584 6.07824V6.07875ZM4.96779 4.75804C4.54047 5.47368 4.35704 6.19656 4.44591 6.87449C4.54047 7.59995 4.95642 8.35229 5.88237 9.04985C6.80884 9.74844 7.65986 9.95048 8.39773 9.84765C9.06842 9.75464 9.70604 9.40018 10.2641 8.8225L4.96779 4.75804ZM7.86965 13.9669L3.80002 10.54C3.68227 10.4408 3.53862 10.3773 3.38598 10.3569C3.23334 10.3366 3.07806 10.3602 2.93842 10.4252C2.79879 10.4901 2.68061 10.5936 2.59781 10.7234C2.515 10.8532 2.47102 11.004 2.47104 11.158V13.9669H7.86965Z" fill="#F0F0F0"/>
                <path d="M11.4454 1.46017C10.938 0.964128 10.2239 0.847867 9.61781 1.10571C9.56347 1.12887 9.52056 1.17266 9.49852 1.22746C9.47647 1.28226 9.4771 1.34357 9.50026 1.39791C9.52342 1.45224 9.56721 1.49516 9.62201 1.5172C9.67681 1.53925 9.73812 1.53862 9.79246 1.51546C10.2342 1.32738 10.7566 1.40953 11.1344 1.77898C11.5141 2.14895 11.6371 2.707 11.4878 3.19736C11.4793 3.22535 11.4764 3.25474 11.4793 3.28384C11.4822 3.31295 11.4908 3.3412 11.5045 3.36699C11.5183 3.39278 11.5371 3.4156 11.5597 3.43415C11.5823 3.4527 11.6084 3.46661 11.6363 3.47509C11.6643 3.48357 11.6937 3.48646 11.7228 3.48358C11.7519 3.48071 11.7802 3.47213 11.806 3.45833C11.8318 3.44454 11.8546 3.4258 11.8731 3.40319C11.8917 3.38057 11.9056 3.35453 11.9141 3.32654C12.1084 2.68736 11.9513 1.95363 11.4454 1.46017Z" fill="#F0F0F0"/>
              </svg>
            </button>
            <button
              onClick={() => {
                showComponent("Area of Interest");
              }}
              className={`second__header__icons__section__icon ${component === "Area of Interest" && 'active'}`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M13.125 1.86566C13.1235 1.37943 12.9329 0.91287 12.5934 0.564775C12.2539 0.216679 11.7923 0.0143863 11.3063 0.000738134C10.8202 -0.0129101 10.348 0.163158 9.98948 0.491655C9.631 0.820151 9.41446 1.27528 9.38571 1.76066L3.55576 2.92646C3.41946 2.64315 3.21393 2.39877 2.95818 2.21591C2.70244 2.03306 2.40472 1.91762 2.09256 1.88026C1.78039 1.84291 1.46384 1.88485 1.17218 2.00221C0.880507 2.11957 0.623128 2.30856 0.423827 2.55171C0.224526 2.79486 0.0897337 3.08433 0.0319084 3.39335C-0.025917 3.70238 -0.00490938 4.021 0.0929895 4.31977C0.190888 4.61853 0.36252 4.88779 0.59202 5.10267C0.82152 5.31755 1.10148 5.47111 1.40604 5.54916V9.43235C1.08634 9.51441 0.79404 9.6796 0.558815 9.91114C0.323589 10.1427 0.153809 10.4323 0.0667059 10.7507C-0.020397 11.0691 -0.0217214 11.4048 0.062867 11.7239C0.147455 12.0429 0.314945 12.3339 0.548337 12.5673C0.781728 12.8007 1.07271 12.9681 1.39175 13.0527C1.7108 13.1373 2.04654 13.136 2.3649 13.0489C2.68327 12.9618 2.97292 12.792 3.20446 12.5568C3.43601 12.3216 3.6012 12.0293 3.68327 11.7096H7.56646C7.64439 12.0143 7.79789 12.2945 8.01279 12.5242C8.22769 12.7539 8.49704 12.9257 8.79593 13.0238C9.09482 13.1218 9.41361 13.1429 9.72281 13.0851C10.032 13.0272 10.3216 12.8924 10.5649 12.693C10.8082 12.4936 10.9973 12.2361 11.1146 11.9442C11.232 11.6524 11.2739 11.3357 11.2365 11.0234C11.199 10.711 11.0834 10.4132 10.9004 10.1574C10.7173 9.90159 10.4727 9.69607 10.1892 9.55985L11.355 3.72991C11.8322 3.70382 12.2814 3.4962 12.6105 3.14958C12.9396 2.80297 13.1237 2.34361 13.125 1.86566ZM11.25 0.928142C11.4354 0.928142 11.6166 0.983126 11.7708 1.08614C11.925 1.18916 12.0452 1.33558 12.1161 1.50689C12.1871 1.67819 12.2056 1.8667 12.1695 2.04856C12.1333 2.23042 12.044 2.39747 11.9129 2.52858C11.7818 2.65969 11.6147 2.74898 11.4329 2.78516C11.251 2.82133 11.0625 2.80277 10.8912 2.73181C10.7199 2.66085 10.5735 2.54069 10.4704 2.38651C10.3674 2.23234 10.3124 2.05108 10.3124 1.86566C10.3127 1.61709 10.4115 1.37877 10.5873 1.20301C10.7631 1.02724 11.0014 0.92839 11.25 0.928142ZM0.937278 3.74069C0.937278 3.55527 0.992262 3.37401 1.09528 3.21983C1.19829 3.06566 1.34471 2.9455 1.51602 2.87454C1.68733 2.80358 1.87584 2.78501 2.0577 2.82119C2.23956 2.85736 2.40661 2.94665 2.53772 3.07776C2.66883 3.20888 2.75812 3.37593 2.7943 3.55779C2.83047 3.73965 2.81191 3.92815 2.74095 4.09946C2.66999 4.27077 2.54983 4.41719 2.39565 4.5202C2.24148 4.62322 2.06022 4.6782 1.87479 4.6782C1.62623 4.67796 1.38791 4.5791 1.21214 4.40334C1.03638 4.22757 0.937526 3.98926 0.937278 3.74069ZM1.87479 12.1783C1.68937 12.1783 1.50811 12.1233 1.35394 12.0203C1.19976 11.9173 1.0796 11.7709 1.00864 11.5996C0.937684 11.4283 0.919118 11.2398 0.955292 11.0579C0.991466 10.8761 1.08076 10.709 1.21187 10.5779C1.34298 10.4468 1.51003 10.3575 1.69189 10.3213C1.87375 10.2851 2.06226 10.3037 2.23357 10.3747C2.40488 10.4456 2.5513 10.5658 2.65431 10.72C2.75733 10.8741 2.81231 11.0554 2.81231 11.2408C2.81206 11.4894 2.71321 11.7277 2.53745 11.9035C2.36168 12.0792 2.12336 12.1781 1.87479 12.1783ZM7.56646 10.7721H3.68327C3.5993 10.4498 3.43088 10.1557 3.19539 9.92022C2.95989 9.68473 2.66584 9.51631 2.34355 9.43235V5.54916C2.72655 5.44953 3.06804 5.23091 3.31883 4.92478C3.56962 4.61864 3.71675 4.2408 3.73905 3.84569L9.569 2.67989C9.75272 3.05781 10.0579 3.36317 10.4357 3.54709L9.26993 9.37656C8.87481 9.39886 8.49698 9.546 8.19084 9.79678C7.88471 10.0476 7.66608 10.3891 7.56646 10.7721ZM9.37493 12.1783C9.18951 12.1783 9.00825 12.1233 8.85407 12.0203C8.6999 11.9173 8.57974 11.7709 8.50878 11.5996C8.43782 11.4283 8.41925 11.2398 8.45543 11.0579C8.4916 10.8761 8.58089 10.709 8.71201 10.5779C8.84312 10.4468 9.01017 10.3575 9.19203 10.3213C9.37389 10.2851 9.5624 10.3037 9.7337 10.3747C9.90501 10.4456 10.0514 10.5658 10.1544 10.72C10.2575 10.8741 10.3124 11.0554 10.3124 11.2408C10.3122 11.4894 10.2133 11.7277 10.0376 11.9035C9.86182 12.0792 9.6235 12.1781 9.37493 12.1783Z" fill="#F0F0F0"/>
              </svg>
            </button>
          </div>
          <div className='second__header__search__section'>
            <span className='fs-16 opacity-75'>{component === 'Satellite' ? 'Satellites' : component}</span>
            <button className='fe fe-search bg-transparent fs-16  opacity-75'/>
          </div>
        </div>


        <div className="mission__model__sidebar__body__container">
          {Object?.keys(SidebarData)?.length > 0 && SidebarData?.[component]?.map((item:any) => (
            <Fragment key={item?.name}>
              {component  === 'Satellite' && 
                <SpaceObjectContainer
                  PlaneObject={item}
                  setVisualisationProperties={(name, id)=>{setVisualisationProperties(name,id)}}
                  openModal={(data: any)=>{openModal(data)}}
                  props = {props}
                />
              }
              {component  === "Ground Station" && 
                <GsSpaceObjectContainer
                  GsObject={item}
                  setVisualisationProperties={(name, id)=>{setVisualisationProperties(name,id)}}
                  openModal={(data: any)=>{openModal(data)}}
                  props={props}
                />
              }
              {component  === "Area of Interest" && 
                <AoiSpaceObjectContainer
                  AoiObject={item}
                  setVisualisationProperties={(name, id)=>{setVisualisationProperties(name,id)}}
                  openModal={(data: any)=>{openModal(data)}}
                  props = {props}
                />
              }
            </Fragment>
          ))}
        </div>
    </div>
      );
};

export default Sidebar;
